import client from "../client";

export interface GetByVenderStatisticsRequest {
  vender_prefix: string;
}

export interface GetByVenderStatisticsResponse {
  BetCount?: number;
  IncomeAmountTotal?: number;
  BetAmountTotal?: number;
  MemberCount?: number;
  HighestIncome?: number;
}

export default function API(
  request: GetByVenderStatisticsRequest
): Promise<GetByVenderStatisticsResponse> {
  return client
    .get(`genaral/get_by_vender_statistics`, { params: request })
    .then((response) => response.data);
}
